<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar
        color="white"
        flat
        :class="{ 'cta-blurred-card': isCallToActionWidget }"
      >
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Leads Sent vs. Quarterly Cap</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>

      <v-container fluid :class="{ 'cta-blurred-card': isCallToActionWidget }">
        <v-row
          v-if="loading && !isCallToActionWidget"
          align="center"
          justify="center"
        >
          <v-col class="pt-0">
            <div class="dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-list class="mb-2" style="width: 100%" dense>
            <v-list-item v-for="item in summary" :key="item.status">
              <v-row>
                <v-col cols="2" class="pr-0">
                  <v-icon color="#badbd3">{{ item.icon }}</v-icon>
                </v-col>
                <v-col>
                  <v-list-item-title
                    v-text="item.title"
                    class="font-weight-light leads-limit-summary-text"
                  />
                </v-col>

                <v-col cols class="pl-0">
                  <v-list-item-action class="text-right justify-end">
                    <span
                      class="pr-4 funnel-count text-h6 leads-limit-summary-data"
                      >{{ item.count }}</span
                    >
                  </v-list-item-action>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-row>
      </v-container>

      <overview-call-to-action-widget
        v-if="isCallToActionWidget"
        :cta-text="ctaText"
        :title="dialogTitle"
        :description="dialogDescription"
        class="call-to-action-widget"
      />
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/services/api.js";
import OverviewCallToActionWidget from "@/components/console/dashboard/OverviewCallToActionWidget";
import C from "@/utils/constants";
import useFormatters from "@/mixins/formatters";

export default {
  name: "console-overview-leads-by-status",
  components: { OverviewCallToActionWidget },
  props: {
    isCallToActionWidget: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      dialogTitle: "",
      dialogDescription: "",
      ctaText: "",
      loading: false,
      summary: [],
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    ...useFormatters(),
    async loadStats() {
      this.loading = true;
      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage && brokerage.id) {
        try {
          let now = new Date();
          let month = `${now.getMonth() + 1}`.padStart(2, "0");
          let params = {
            ingestedDate: `${now.getFullYear()}-${month}`,
          };

          let { data } = await api.leads.leadStats(brokerage.id, params);

          let leadsSent = 0;
          let duplicates = 0;
          let cap = "N/A";

          if (data.content && data.content.length > 0) {
            let result = data.content[0];

            if (result.ingestedCount) {
              leadsSent = result.ingestedCount;
            }

            if (result.duplicateCount) {
              duplicates = result.duplicateCount;
            }

            if (result.quarterlyCap) {
              cap = result.quarterlyCap;
            }
          }

          this.summary = [
            { icon: "fas fa-envelope", title: "Leads Sent", count: leadsSent },
            { icon: "fas fa-copy", title: "Duplicates", count: duplicates },
            { icon: "fas fa-chart-line", title: "Quarterly Cap", count: cap },
          ];
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewLeadsLimitToolTip");
    },
  },
  mounted() {
    if (this.isCallToActionWidget) {
      this.summary = [...C.LEADS_LIMITS_DUMMY_DATA];
      this.ctaText = C.LEADS_LIMITS_CTA_TEXT;
      this.dialogTitle = "Leads Limit";
      this.dialogDescription = C.LEADS_LIMITS_CTA_DESCRIPTION;
    } else {
      this.loadStats();
    }
  },
};
</script>

<style scoped>
.leads-limit-summary-text {
  font-size: 14px !important;
}
.leads-limit-summary-data {
  color: black;
}

.call-to-action-widget {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.cta-blurred-card {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  filter: blur(4px);
  opacity: 0.7;
  pointer-events: none;
}
/*See ConsoleOverview for non-scoped classes*/
</style>
